import React from "react";
import NetworkActionSection from "./NetworkActionSection";
import DataComponent from "components/common/DataComponent";

const NetworkDataSection = ({ PK, isUserAllowed}) => {
  return (
    <div
      id="site-section"
      style={{
        backgroundColor: "white",
        padding: "2% 2%",
        border: "3px solid #f6f6f6",
        borderRadius: "10px",
      }}
    >
      <DataComponent />
      {PK && <NetworkActionSection PK={PK} isUserAllowed={isUserAllowed}/>}
    </div>
  );
};

export default NetworkDataSection;
